import toaster, { ToastOptions } from 'react-hot-toast';

import { AlertError, AlertInfo, AlertSuccess, AlertWarning } from '@/components/common';
import { ALERT_DURATION, ALERT_FADE_DURATION } from '@/constants';

export const showAlertInfo = (message: string, options?: ToastOptions) => {
  toaster.custom((t) => <AlertInfo message={message} t={t} />, options);
};

// Queue to manage error toasts, ensuring they display one at a time
const errorQueue: { message: string; options?: ToastOptions }[] = [];
let isErrorShowing = false;

const showNextError = () => {
  if (errorQueue.length === 0) {
    isErrorShowing = false;
    return;
  }

  isErrorShowing = true;
  const next = errorQueue.shift();
  if (!next) return;
  const { message, options } = next;
  const duration = options?.duration ?? ALERT_DURATION;

  toaster.custom((t) => <AlertError message={message} t={t} />, {
    ...options,
    duration: duration,
  });

  setTimeout(() => {
    showNextError();
  }, duration + ALERT_FADE_DURATION);
};

export const showAlertError = (message: string, options?: ToastOptions) => {
  errorQueue.push({ message, options });

  if (!isErrorShowing) {
    showNextError();
  }
};

export const showAlertSuccess = (message: string, options?: ToastOptions) => {
  toaster.custom((t) => <AlertSuccess message={message} t={t} />, options);
};

export const showAlertWarning = (message: string, options?: ToastOptions) => {
  toaster.custom((t) => <AlertWarning message={message} t={t} />, options);
};
